import {minBy, values} from 'lodash'
import {FlyoutPosition} from './FlyoutPosition'

const none = position => position

const inverse = (overflows, position) => {
  if (overflows[position].ovrfl <= 0) return position
  const inversePosition = (position + 2) % values(FlyoutPosition).length
  return minBy([overflows[position], overflows[inversePosition]], 'ovrfl').pos
}
const clockwise = (overflows, position) => {
  if (overflows[position].ovrfl <= 0) return position
  const vals = values(FlyoutPosition)
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vals.length; i++) {
    const pos = (position + i) % vals.length
    if (overflows[pos].ovrfl <= 0) return overflows[pos].pos
  }
  return position
}

const minOverflow = (overflows, position) => {
  if (overflows[position].ovrfl <= 0) return position
  return minBy(overflows, 'ovrfl').pos
}

const OverflowStrategy = {
  none,
  inverse,
  clockwise,
  minOverflow,
}

export default OverflowStrategy
